<template>

<com-content :loading="is.loading" :empty="!photos.length" :text="text" class="photos-wrapper">

    <div class="photos">

        <div class="photos-item" v-on:click="onPhotoClick(index)" v-tooltip="page.photos_tooltip" v-for="(photo, index) in photos" :key="index" :style="{backgroundImage: $util.thumbnail(photo.image)}"></div>

    </div>

</com-content>

</template>

<script>

import comContent from './common/Content'

export default {

    components: {
        'com-content': comContent
    },

    data: function() {

        return {
            is: {
                loading: false
            },
            photos: []
        }

    },

    computed: {

        text: function() {

            return {
                empty: this.page.photos_empty
            }

        }

    },

    created: function() {

        this.fetch()

    },

    methods: {

        onPhotoClick: function(index) {

            this.$pubsub.$emit('photos.open', {
                photos: this.photos,
                index: index
            })

        },

        fetch: function() {

            this.is.loading = true

            this.$api.request('business/photos', {
                slug: this.page.business.slug
            }).then(function(json) {

                this.photos = json.photos

				this.is.loading = false

				if (this.$route.params.hash) {

					var autoloadIndex = 0

					this.$_.each(this.photos, function(photo, index) {

						if (photo.identity === this.$route.params.hash) autoloadIndex = index

					}.bind(this))

					this.$pubsub.$emit('photos.open', {
						photos: this.photos,
						index: autoloadIndex
					})

					this.$router.replace({
						name: 'Business/Photos'
					})

				}

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.photos-wrapper {
    padding: 20px 0px!important;
}

.is-mobile .photos-wrapper {
    padding: 10px 0px!important;
}

.photos {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}

.photos-item {
    width: 120px;
    height: 120px;
    background-size: cover;
    background-position: 50% 50%;
    border-radius: 4px;
    margin: 20px;
    cursor: pointer;
}

.is-mobile .photos-item {
    margin: 5px;
    width: 92px;
    height: 92px;
}

</style>